import React from 'react';
import { Navigate, useLocation } from 'react-router';

const TeacherSignupRedirect: React.FC = () => {
  const location = useLocation();
  const search = location.search || '';

  return <Navigate to={`/auth/signup/teacher${search}`} replace />;
};

export default TeacherSignupRedirect;
